module.exports = __webpack_public_path__ + "static/media/cutsglare_spanish_00045.098747b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/es/cutsglare_spanish_00045.png
// module id = 1373
// module chunks = 0